import common from './components/common';
import productCards from './blocks/product-cards';
import partsCatalog from './blocks/parts-catalogs';
import searchAspProducts from './blocks/search-asp-products';
import productDetails from './pages/product-details';

(function() {
    common();
    productCards();
    partsCatalog();
    searchAspProducts();
    productDetails();
})();
